import { render, staticRenderFns } from "./ProjectSetting.vue?vue&type=template&id=5f6c7432&scoped=true"
import script from "./ProjectSetting.vue?vue&type=script&lang=js"
export * from "./ProjectSetting.vue?vue&type=script&lang=js"
import style0 from "./ProjectSetting.vue?vue&type=style&index=0&id=5f6c7432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c7432",
  null
  
)

export default component.exports